import React from "react";
import cx from "clsx";
import styles from "./styles.module.scss";

export const Row = ({
  children,
  className,
  gap = "8px",
  alignItems = "center",
  justifyContent = "flex-start",
}) => (
  <div
    className={cx(styles.root, className)}
    style={{ gap, alignItems, justifyContent }}
  >
    {children}
  </div>
);
